import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { DATATABLE_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

class Modifier extends Component {

    state = {
        selectedItems: [],
        globalFilter: '',
        ModifierId: '',
        ModifierCode: '',
        ModifierName: '',
        branchId: '',
    };

    // componentDidMount() {
    // ✅ Set access rights
    // this.getAccess = HASACCESS(USER_SUBMENU_ID);

    // ✅ Fetch store list — calls GET /api/res/GetInvStoreList?companyid=XXX
    // this.props.getMasterTableList('res/GetInvStoreList', this.props.loggedUserDetail.CompanyId);
    // }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        this.props.getMasterTableList('res/GetresModifierList', this.props.loggedUserDetail.CompanyId)  // Fetches branch data
        // Get the type and id from URL params
        let type = this.props.match.params.type;  // 'add', 'edit', or 'view'
        let id = this.props.match.params.id;

        console.log('Component mounted with type:', type, 'id:', id);
    }

    componentDidUpdate(prevProps) {
        // Update state when store data is loaded
        if (
            this.props.tableLists &&
            this.props.tableLists !== prevProps.tableLists
        ) {
            this.setState({
                ModifierId: this.props.tableLists.modifierId,
                ModifierCode: this.props.tableLists.modifierCode,
                ModifierName: this.props.tableLists.modifierName,
                // Add other fields as needed
            });
        }
    }

    // ✅ Action buttons: Edit + View
    actionTemplate = (rowData) => (
        <div className="actionCenter">
            {this.getAccess?.editAccess !== false &&
                <Link to={`/modifier/edit/${rowData.modifierId}`}>
                    <Button type="button" icon="pi pi-pencil" className="p-button-info" />
                </Link>
            }
            {this.getAccess?.viewAccess !== false &&
                <Link to={`/modifier/view/${rowData.modifierId}`}>
                    <Button type="button" icon="pi pi-eye" className="p-button-secondary" />
                </Link>
            }
        </div>
    );

    // ✅ Active/Inactive badge
    statusRender = (rowData) => (
        <div className="actionCenter">
            {(rowData.isActive === true || rowData.isActive === null)
                ? <Button type="button" label="Active" className="p-button-success p-button-rounded" />
                : <Button type="button" label="Inactive" className="p-button-danger  p-button-rounded" />
            }
        </div>
    );


    render() {
        // ✅ Redirect if no view access
        if (this.getAccess?.viewAccess === false) {
            this.props.history.push('/dashboard');
            return null;
        }

        const header = (
            <div style={{ textAlign: 'right' }}>
                <InputText
                    type="search"
                    onInput={(e) => this.setState({ globalFilter: e.target.value })}
                    placeholder="Search modifiers..."
                />
            </div>
        );

        let tableData = [];
        if (this.props.tableLists !== undefined) {
            tableData = this.props.tableLists;
        }
        return (
            <div className="p-grid padding">

                {/* Loader & Messages */}
                {this.props.loading && <div className="page-loader" />}
                {this.props.error && <Messages type="error" message={this.props.error} />}
                {this.props.success && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => (this.growl = el)} />

                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Modifier Master</h1>

                        <div className="p-grid">
                            {/* Toolbar */}
                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                    {this.getAccess?.addAccess !== false &&
                                        <Link to="/modifier/add/new">
                                            <Button
                                                style={{ float: 'right' }}
                                                label="Add Modifier"
                                                icon="pi pi-plus"
                                                className="ml1"
                                            />
                                        </Link>
                                    }
                                    {/* {this.getAccess?.deleteAccess !== false &&
                                        <Button
                                            style={{ float: 'right' }}
                                            label="Delete"
                                            icon="pi pi-trash"
                                            className="p-button-danger"
                                            onClick={this.delete}
                                        />
                                    } */}
                                </div>
                            </div>

                            {/* Data Table */}
                            <div className="p-col-12" style={{ marginTop: '2em' }}>
                                <DataTable
                                    value={tableData}
                                    selection={this.state.selectedItems}
                                    onSelectionChange={(e) => this.setState({ selectedItems: e.value })}
                                    globalFilter={this.state.globalFilter}
                                    header={header}
                                    emptyMessage="No modifiers found."
                                    {...DATATABLE_CONFIG}
                                >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="modifierId" header="Modifier ID" sortable />
                                    <Column field="branchId" header="Branch ID" />
                                    {/* <Column field="branchCode" header="Branch Code" /> */}
                                    <Column field="modifierCode" header="Modifier Code" />
                                    <Column field="modifierName" header="Modifier Name" />
                                    {/* <Column field="customerNumber" header="Customer Number" /> */}
                                    {/* <Column field="mobileNumber" header="Mobile Number" /> */}
                                    {/* <Column field="email" header="Email" /> */}
                                    {/* <Column field="isActive" header="Status" body={this.statusRender} sortable /> */}
                                    <Column header="Action" body={this.actionTemplate} />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUserDetail: state.auth.userObject,
    loading: state.master.loading,
    error: state.master.error,
    success: state.master.success,
    tableLists: state.master.tableLists,
});

const mapDispatchToProps = (dispatch) => ({
    getMasterTableList: (table, company) => dispatch(actions.getMasterTableList(table, company)),
    dynamicDeleteProcess: (model, data, func) => dispatch(actions.dynamicDeleteProcess(model, data, func)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modifier);